export class AppError extends Error {
    statusCode;
    isOperational;
    constructor(statusCode, message, isOperational = true, stack = ``) {
        super(message);
        this.statusCode = statusCode;
        this.isOperational = isOperational;
        if (stack) {
            this.stack = stack;
        }
        else if (Error.captureStackTrace) {
            Error.captureStackTrace(this, this.constructor);
        }
        else {
            this.stack = new Error(message).stack;
        }
    }
    toResponse() {
        return {
            message: this.message,
        };
    }
}
